import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { PullToRefresh, InfiniteScroll, DotLoading } from 'antd-mobile'
import { POST } from '../../util/http'
import './orders.less'

const statusObj = { 1: '待确认打款', 2: '回款中', 3: '已结束' };

const Orders = () => {
  const [state, setState] = useState({
    listData: null,
    page: 1,
    pageSize: 10,
    hasMore: true
  })

  const setData = (obj={}) => {
    setState(st => ({ ...st, ...obj }));
  }
  const onRefresh = async () => {   //下拉刷新
    await loadDataFun('refresh');
  }
  const loadMore = async () => {   //上拉加载更多 loadMore需要返回一个Promise，用于自动对 loadMore 函数加锁，避免重复的请求
    let { listData, pageSize } = state, _len = (listData && listData.length) || 0;
    if (listData && (_len<pageSize || _len%pageSize!=0)) return;
    await loadDataFun('more');
  }
  const loadDataFun = async (gType) => {
    let { listData, page, pageSize } = state;
    page = gType=='refresh' || !listData ? 1 : ++page;

    return new Promise(async (resolve, reject) => {
      const res = await POST('getOrderList', { page, pageSize }, true, true);
      resolve(res);
      analysisListData(gType, page, res);
    })
  }
  const analysisListData = async (gType, page, res) => {
    let { listData, pageSize, hasMore } = state, _list = res.data || [];

    if (res.code != 0){
      setData({ listData:[], page, hasMore: false });
      return;
    }

    if (gType=='more' && _list.length < pageSize){
      hasMore = false;
      if (!_list.length && page>1) page--;
    }

    _list.forEach(item => {
      let { status, createTime, confirmTime, startTime, endTime, onePeriodPrincipal, onePeriodInterest } = item;
      item.statusTxt = statusObj[status];
      item.createTime = createTime && React.$dayjs(createTime*1000).format('YYYY/MM/DD');
      item.confirmTime = confirmTime && React.$dayjs(confirmTime*1000).format('YYYY/MM/DD');
      item.startTime = startTime && React.$dayjs(startTime*1000).format('YYYY/MM/DD');
      item.endTime = endTime && React.$dayjs(endTime*1000).format('YYYY/MM/DD');
      item.onePeriodTotal = onePeriodPrincipal||onePeriodPrincipal=='0' ? (onePeriodInterest||onePeriodInterest=='0' ? +(onePeriodPrincipal+onePeriodInterest).toFixed(2) : onePeriodPrincipal) : (onePeriodInterest||onePeriodInterest=='0' ? onePeriodInterest : '');
    })
    setData({ 
      page, 
      hasMore, 
      listData: gType=='more' ? [...(listData||[]), ..._list] :  _list 
    })

  }

  return (
    <div className="orders-wrap">
      <PullToRefresh onRefresh={onRefresh}>{state.listData && state.listData.length ? 
        <ul className='lists'>
            {state.listData.map((item, index) => 
            <li className='items' key={index}>
              <p className='cnts'>
                <span className='cnt-name'>订单号：</span>
                <span className='cnt-val'>{item.orderNo}</span>
                <span className={`cnt-status ${item.status==1?'cnt-red-status':item.status==2?'cnt-green-status':''}`}>{item.statusTxt}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>下单日期：</span>
                <span className='cnt-val'>{item.createTime}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>认购款到账日期：</span>
                <span className='cnt-val'>{item.confirmTime}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>收益起始日期：</span>
                <span className='cnt-val'>{item.startTime?`${item.startTime}`:'-'}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>投资期数：</span>
                <span className='cnt-val'>{item.period||'-'}期 (每期{item.onePeriodDay||'-'}天)</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>投资周期：</span>
                <span className='cnt-val'>{item.startTime && item.endTime ?`${item.startTime} - ${item.endTime}` : '-'}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>认购资产数量：</span>
                <span className='cnt-val'>{item.propertyNum}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>资产单价：</span>
                <span className='cnt-val'>{item.propertyPrice}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>年投资收益费率：</span>
                <span className='cnt-val'>{+(item.rate||0)}%</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>认购资产本金：</span>
                <span className='cnt-val'>{item.propertyTotalPrice}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>投资总计收益：</span>
                <span className='cnt-val'>{item.totalInterest}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>每期回款本金：</span>
                <span className='cnt-val'>{item.onePeriodPrincipal}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>每期回款收益：</span>
                <span className='cnt-val'>{item.onePeriodInterest}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>每期回款总额：</span>
                <span className='cnt-val'>{item.onePeriodTotal}</span>
              </p>
              <p className='cnts'>
                <span className='cnt-name'>累计已回款金额：</span>
                <span className='cnt-val'>{item.receiveAmount} (已回款{item.receivePercentage||0}%)</span>
              </p>
            </li>
          )}
        </ul> : ''}
        {state.listData && !state.listData.length ? <div className='nomore'>暂无数据</div> : ''}
      </PullToRefresh>
      
      <InfiniteScroll loadMore={loadMore} hasMore={state.hasMore}>
        {state.hasMore ? (<><span>加载中</span><DotLoading /></>) : (state.listData && state.listData.length && state.listData.length.length>2 ? <span>--- 我是有底线的 ---</span> : '')}
      </InfiniteScroll>

    </div>
  )
}

export default withRouter(Orders);